interface SVGIconI extends Omit<React.SVGProps<SVGSVGElement>, "title"> {
  children: React.ReactNode;
  title: string;
  viewBox: string;
}

function SVGIcon(props: SVGIconI) {
  return (
    <svg
      viewBox={props.viewBox}
      width={props.width || props.height ? undefined : "1em"}
      height={props.height || undefined}
      role="img"
      aria-label={props.title}
      {...props}
      className={`ctm-icon${props.className ? ` ${props.className}` : ""}`}
    >
      {props.children}
    </svg>
  );
}

export default SVGIcon;
